import Phaser from 'phaser';
import { CONSTANTS } from './constants';

export const GAME_CONFIG = {
  width: CONSTANTS.CANVAS_WIDTH,
  height: CONSTANTS.CANVAS_HEIGHT,
  renderer: Phaser.AUTO,
  physics: {
    gravity: { x: 0, y: CONSTANTS.GRAVITY * 60 },
    debug: false,
  },
  worldWidth: CONSTANTS.WORLD_WIDTH,
} as const;

export const ASSET_PATHS = {
  characters: 'assets/characters/',
  enemies: 'assets/enemies/',
  npcs: 'assets/npcs/',
  environment: 'assets/environment/',
  powerups: 'assets/powerups/',
  ui: 'assets/ui/',
  audio: 'assets/audio/',
} as const;

export const SCENE_KEYS = {
  BOOT: 'BootScene',
  PRELOAD: 'PreloadScene',
  MENU: 'MenuScene',
  GAME: 'GameScene',
  LEVEL_COMPLETE: 'LevelCompleteScene',
  BRIEFING: 'BriefingScene',
  FINAL: 'FinalScene',
  DEFEAT: 'DefeatScene',
} as const;

export const LEVEL_IDS = {
  CENTER_HABANA: 'level-1',
} as const;
